(function () {
  if (window.__nestFreeComfortBundleLreRowSync20260703) return;
  window.__nestFreeComfortBundleLreRowSync20260703 = true;

  var targetHandles = [
    'sparrow-signature-hybrid-mattress',
    'owl-natural-latex-hybrid-mattress',
    'starling-signature-contour-grid'
  ];
  var timer = null;
  var mobileQuery = window.matchMedia ? window.matchMedia('(max-width: 749px)') : null;

  function handle() {
    var match = window.location.pathname.match(/\/products\/([^/?#]+)/);
    return match ? match[1] : '';
  }

  function isTargetProduct() {
    return targetHandles.indexOf(handle()) !== -1;
  }

  function isMobile() {
    return mobileQuery ? mobileQuery.matches : window.innerWidth <= 749;
  }

  function normalize(value) {
    return String(value || '')
      .replace(/\s+/g, ' ')
      .replace(/california/ig, 'cal')
      .trim()
      .toLowerCase();
  }

  function sizeSelect() {
    return document.querySelector('.product-template__container #product-detail-size-chooser');
  }

  function selectedSize() {
    var select = sizeSelect();
    if (!select) return '';

    var wrapper = select.closest ? select.closest('.select') : select.parentElement;
    var styled = wrapper && wrapper.querySelector ? wrapper.querySelector('.styledSelect') : null;
    var styledText = styled ? styled.textContent : '';
    var optionText = select.options && select.options[select.selectedIndex] ? select.options[select.selectedIndex].text : '';
    var value = select.value || optionText || styledText;

    if (styledText && normalize(styledText) !== normalize(value)) {
      value = styledText;
    }

    return value;
  }

  function matchingRow(rows, size) {
    var normalizedSize = normalize(size);
    var fallback = null;

    for (var i = 0; i < rows.length; i += 1) {
      var rowSize = normalize(rows[i].getAttribute('data-size'));
      if (!fallback) fallback = rows[i];
      if (rowSize === normalizedSize) return rows[i];
    }

    return fallback;
  }

  function setClass(row, name, enabled) {
    if (row.classList.contains(name) !== enabled) row.classList.toggle(name, enabled);
  }

  function setAttribute(row, name, value) {
    if (row.getAttribute(name) !== value) row.setAttribute(name, value);
  }

  function setStyle(row, property, value) {
    if (row.style.getPropertyValue(property) === value && row.style.getPropertyPriority(property) === 'important') return;
    row.style.setProperty(property, value, 'important');
  }

  function setVisible(row, visible) {
    setClass(row, 'active', visible);
    setClass(row, 'is-active', visible);
    setAttribute(row, 'aria-hidden', visible ? 'false' : 'true');
    setStyle(row, 'display', visible ? 'flex' : 'none');
    if (visible) {
      setStyle(row, 'visibility', 'visible');
      setStyle(row, 'opacity', '1');
    }
  }

  function syncBundleRow() {
    if (!isTargetProduct() || !isMobile()) return;

    var rows = Array.prototype.slice.call(document.querySelectorAll('.product-template__container .comfort-bundle-products .comfort-bundle-product.bundle-flex.comfort-bundle-lre[data-size]'));
    if (!rows.length) return;

    var row = matchingRow(rows, selectedSize());
    rows.forEach(function (candidate) {
      setVisible(candidate, candidate === row);
    });
  }

  function scheduleSync() {
    if (timer) window.clearTimeout(timer);
    timer = window.setTimeout(function () {
      timer = null;
      syncBundleRow();
    }, 40);
  }

  function bind() {
    syncBundleRow();
    [80, 200, 500, 1000, 1800].forEach(function (delay) {
      window.setTimeout(syncBundleRow, delay);
    });

    document.addEventListener('change', function (event) {
      if (event.target && event.target.matches && event.target.matches('#product-detail-size-chooser')) scheduleSync();
    }, true);

    document.addEventListener('click', function (event) {
      if (event.target && event.target.closest && event.target.closest('.product-detail-description-right .select, .product-detail-description-right .options li, .product-detail-description-right .styledSelect')) {
        scheduleSync();
        window.setTimeout(syncBundleRow, 120);
      }
    }, true);

    if (window.MutationObserver && document.documentElement) {
      new MutationObserver(scheduleSync).observe(document.documentElement, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'style', 'selected']
      });
    }

    if (mobileQuery && mobileQuery.addEventListener) mobileQuery.addEventListener('change', scheduleSync);
  }

  if (!isTargetProduct()) return;
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind, { once: true });
  } else {
    bind();
  }
})();